import { KYMW0A00Model } from '../kymw0a00.model';
import { MembersVoiceSearchModel } from '../vo/members-voice-search.model';
import { PlessResponderSub } from '../../../../commons/kymw00/pless-responder-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 組合員の声一覧を取得するサービス
 *
 * @export GetMembersVoiceSearchListService
 * @class GetMembersVoiceSearchListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMembersVoiceSearchListService extends PlessJsonResponderSub<any> {
  private model: KYMW0A00Model = null;
  private vo: MembersVoiceSearchModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMembersVoiceSearchListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ReceiptNumFrom: this.vo.receiptNumFrom,
        ReceiptNumTo: this.vo.receiptNumTo,
        ClassCode: this.vo.classCode,
        Subject: this.vo.subject,
        InquiryContents: this.vo.inquiryContents,
        ReceiptDateFrom: this.vo.receiptDateFrom,
        ReceiptDateTo: this.vo.receiptDateTo,
        PublishType: this.vo.publishType,
        CoopCode: this.vo.coopCode,
        ImportDateFrom: this.vo.importDateFrom,
        ImportDateTo: this.vo.importDateTo,
        SortItem: this.vo.sortItem,
        SortOrder: this.vo.sortOrder,
        PageNum: `${this.vo.pageNum}`,
        OrderGoodsFlg: this.vo.orderGoodsFlg,
        ItemCode: this.vo.itemCode,
        ReceiptSOrderCode: this.vo.receiptSOrderCode,
        OrderNum6Digits: this.vo.orderNum6Digits
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model KYMW0A00Model
   * @memberof GetMembersVoiceSearchListService
   */
  execute(model: KYMW0A00Model, vo: MembersVoiceSearchModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getMembersVoiceSearchList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMembersVoiceSearchListService
   */
  success(data: any): void {
    this.model.getMembersVoiceSearchList(data);
    this.successFunc();
  }
}
